import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Distributor } from '../../shared/models/Distributor';
import { FilterObject } from '../../shared/models/FilterObject';
import { AutoCompleteObject, PagingResults } from '../../shared/models/PagingResult';
import { User } from '../../shared/models/User';
import { GlobalService } from '../../shared/services/global';
import { HttpService } from '../../shared/services/HttpService';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
  selector: 'app-manage-users',
  templateUrl: './manage-users.component.html',
  styleUrls: ['./manage-users.component.css']
})
export class ManageUsersComponent implements OnInit {
  CurrentPage: number;
  UserList: User[];
  DistList: Distributor[];
  CurrentDist: string;
  CustFilter: FilterObject;
  RoleFilter: FilterObject;
  DistSubscription: Subscription;
  filteredUsers: Observable<AutoCompleteObject[]>;
  userSearchControl = new FormControl();
  UserNameList: AutoCompleteObject[];
  faSearch = faSearch;
  NameFilter: FilterObject;
  FilterList: FilterObject[];
  UserListPageIndex: number;
  UserListPageSize: number;
  UserListCount: number;
  CurrentUser: User;
  readonly PageSizeOptions: number[] = [5, 10, 20, 50];
  constructor(private router: Router, private http: HttpService, private global: GlobalService) { }

  ngOnInit(): void {
    var dist = this.global.getCurrentDist();
    this.global.getCurrentUser().then(x => {
      this.CurrentUser = x;

      this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Manage Users", "Load", "");
      this.UserListPageIndex = 0;
      this.UserListPageSize = 100;
      this.CurrentPage = 0;
      this.FilterList = [];
      this.NameFilter = new FilterObject();
      this.NameFilter.Key = "name";
      this.NameFilter.Value = "";
      this.CustFilter = new FilterObject();
      this.CustFilter.Key = "customer";
      this.RoleFilter = new FilterObject();
      this.RoleFilter.Key = "role";
      this.RoleFilter.Value = this.CurrentUser.IsTolomaticUser ? "all" : "distributor";

      this.FilterList.push(this.NameFilter);
      this.FilterList.push(this.RoleFilter);


      if (this.CurrentUser) {
        if (!this.CurrentUser.IsTolomaticUser) {
          if (!(this.CurrentUser.Role == "distributor-manager" || this.CurrentUser.Role == "administrator")) {
            this.router.navigate(['/']);
          }
        }
      }
      else {
        this.router.navigate(['/']);
      }


      this.http.GetDistributors().then(x => {
        if (x.StatusCode == "200") {
          this.DistList = x.Content;
          var index = 1;
          this.DistList.forEach(dist => {
            dist.SortIndex = index;
            index++;
          });
          var allDist = new Distributor();
          allDist.Company = "All Distributors";
          allDist.CompanyId = "00000000-0000-0000-0000-000000000000";
          allDist.SortIndex = 0;
          this.DistList.push(allDist);
          this.DistList.sort((a, b) => {
            if (a.SortIndex > b.SortIndex) {
              return 1;
            }
            else {
              return -1;
            }
          });
          //this.DistList.push(allDist);
          if (dist) {
            if (!this.CurrentUser.IsTolomaticUser && this.CurrentUser.DistributorId == dist.CompanyId) {
              this.CurrentDist = dist.CompanyId;
            }
            else if (this.CurrentUser.IsTolomaticUser) {
              this.CurrentDist = dist.CompanyId;
            }
            else {
              this.CurrentDist = this.CurrentUser.DistributorId;
            }
          }
          else {
            if (!this.CurrentUser.IsTolomaticUser && this.CurrentUser.DistributorId != "") {
              this.CurrentDist = this.CurrentUser.DistributorId;
            } else {
              this.CurrentDist = this.DistList[0].CompanyId;
            }
          }


          this.CustFilter.Value = this.CurrentDist;

          this.FilterList.push(this.CustFilter);

          //load users
          this.LoadUsers(true);
        }

      });

      var initialLoad = true;
      this.DistSubscription = this.global.CurrentDist.subscribe(dist => {
        debugger;
        if (dist && dist.CompanyId != this.CurrentDist && !initialLoad) {
          this.CurrentDist = dist.CompanyId;
          this.CustFilter.Value = this.CurrentDist;
          this.LoadUsers(true);
        }
        initialLoad = false;
      });

      this.filteredUsers = this.userSearchControl.valueChanges.pipe(
        startWith(''),
        //map(value => {typeof value === 'string' ? value : value.ProjectName}),
        map(projName => (projName ? this._userFilter(projName) : this.UserNameList)),
      );
    });
    
  }

  private _userFilter(value: string): AutoCompleteObject[] {
    if (value && value.length > 0 && value != null) {
      const filterValue = value.toLowerCase();

      if (this.UserNameList && this.UserNameList.length > 0) {
        return this.UserNameList.filter(option => option.Name.toLowerCase().indexOf(filterValue) >= 0);
      }

    }
    return [];
  }


  userAutoComplete_Selected(event: MatAutocompleteSelectedEvent) {
    var selectedProj = <string>event.option.value;

    this.NameFilter.Value = selectedProj;

    this.LoadUsers(false);
  }

  UserListPageEvent(event: any) {

    this.UserListPageIndex = event.pageIndex;
    this.UserListPageSize = event.pageSize;
    this.LoadUsers(false);
  }

  userDisplayFn(user: string) {
    return user && user.length > 0 ? user : '';
  }

  checkUserFilterInput(event: any) {

  }

  Dist_Change(event: any) {
    this.CurrentDist = event.value;
    //this.CustFilter.Value = this.CurrentDist;
    //var newDist = this.DistList.filter(x => x.CompanyId == event.value)[0];
    this.CustFilter.Value = this.CurrentDist;
    this.LoadUsers(true);
    //this.global.setCurrentDist(newDist);
  }

  RoleChange(event: any) {
    this.LoadUsers(true);
  }

  async LoadUsers(getNames: boolean) {

    await this.http.GetUsers(this.UserListPageIndex, this.UserListPageSize, this.FilterList, this.CurrentUser.UserId.toString()).then(x => {
      if (x.StatusCode == "200") {
        var results = (<PagingResults>x.Content);
        this.UserList = results.Items;
        if (results && results.ItemCount) {
          this.UserListCount = results.ItemCount;
        }
        else { this.UserListCount = 0; }
        if (getNames) {
          this.UserNameList = results.NameList;
          //this.http.GetUsersNames().then(names => {
          //  this.UserNameList = names.Content;
          //});
        }
      }
    });
  }

  CreateNewUser() {
    this.router.navigateByUrl('/createuser', { state: { redirectURL: '/admin/manageusers' } });
  }


  Option_Change(event: any, user: User) {
    if (event.value == "edit") {
      this.router.navigateByUrl('/edituser', { state: { User: user, type: "edit", redirectURL: "/admin/manageusers" } });
    } else if (event.value == "resetpassword") {
      this.http.ForgotPassword(user).then(wrap => {
        if (wrap.StatusCode == "200") {

        }
        else {
          var message = wrap.Message;
        }
      });
    }
    else if (event.value == "resendverification") {
      if (user.Role == "inactive") {
        this.http.sendVerificationEmail(user).then(wrap => {
          if (wrap.StatusCode == "200") {

          }
        });
      }
    }

    event.source.value = "";
  }

}
